import React from 'react';
import { Link } from 'react-router-dom';

// Minimal text logo component - Exor/LMDV style
function Logo({ light = false }) {
  return (
    <div className={`flex flex-col items-start leading-none ${light ? 'text-white' : 'text-[#0A192F]'}`}>
      <span className="text-2xl font-light tracking-[0.15em]">BNDV</span>
      <span className="text-[9px] uppercase tracking-[0.35em] opacity-60 mt-0.5">Capital</span>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="bg-[#0A192F] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <Logo light={true} />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              Single Family Office. Private Capital & Strategic Investments through our holding company Dolchester Holding.
            </p>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs uppercase tracking-wider text-slate-500 mb-5">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-slate-400 hover:text-white text-sm transition-colors">About Us</Link></li>
              <li><Link to="/portfolio" className="text-slate-400 hover:text-white text-sm transition-colors">Portfolio</Link></li>
              <li><Link to="/governance" className="text-slate-400 hover:text-white text-sm transition-colors">Governance</Link></li>
              <li><Link to="/news" className="text-slate-400 hover:text-white text-sm transition-colors">News</Link></li>
            </ul>
          </div>

          {/* Investor Relations */}
          <div>
            <h4 className="text-xs uppercase tracking-wider text-slate-500 mb-5">Investors</h4>
            <ul className="space-y-3">
              <li><Link to="/investor-relations" className="text-slate-400 hover:text-white text-sm transition-colors">Investor Relations</Link></li>
              <li><Link to="/investor-relations#documents" className="text-slate-400 hover:text-white text-sm transition-colors">Financial Reports</Link></li>
              <li><Link to="/investor-relations#calendar" className="text-slate-400 hover:text-white text-sm transition-colors">Corporate Calendar</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-wider text-slate-500 mb-5">Headquarters</h4>
            <address className="not-italic text-sm text-slate-400 space-y-2">
              <p>BNDV Capital</p>
              <p>45 Albemarle Street</p>
              <p>London W1S 4JL</p>
              <p>United Kingdom</p>
              <p className="pt-2">
                <a href="mailto:info@bndvcapital.com" className="hover:text-white transition-colors">
                  info@bndvcapital.com
                </a>
              </p>
            </address>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs">
            © {new Date().getFullYear()} BNDV Capital. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-slate-500 hover:text-white text-xs transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-slate-500 hover:text-white text-xs transition-colors">
              Terms
            </Link>
            <Link to="/imprint" className="text-slate-500 hover:text-white text-xs transition-colors">
              Imprint
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
